import React from 'react';
import { Input } from 'web-ui-components/lib/atoms/forms';
import { Field as FormField, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isLetterCodeValid } from '../../../utils/validation';

const AuthCode = () => (
  <Content>
    {({ enterAuthLabel = '', enterAuthError = '' }) => (
      <Field name="authcode" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <FormField>
            <FieldHeader
              name="authcode"
              hasError={touched && !!error}
              title={enterAuthLabel}
              validationMessage={enterAuthError}
            />
            <FieldBody hasError={touched && !!error}>
              <Field name="authcode" component="input" validate={isLetterCodeValid}>
                {({ input }) => <Input name="authcode" minlength="10" type="text" {...input} />}
              </Field>
            </FieldBody>
          </FormField>
        )}
      </Field>
    )}
  </Content>
);

export default AuthCode;
